import React, { useContext, Fragment } from "react";
import { useState } from "react";
import { IoMdAlert } from "react-icons/io";
import { PageNavigation, PatientInfoTable } from "..";
import { PatientRequestsList } from "../PatientRequests/PatientRequestsList";
import { TableContext } from "./PenfastPatientsHospitalPresentTable";
import {
  DateFieldFilter,
  DiagnosisNameFilter,
  NumberFieldFilter,
  SelectFieldFilter,
  TextFieldFilter,
} from "./TableFilter";

export const TableBody = ({ id, ...props }) => {
  const { getTableBodyProps, rows, prepareRow, visibleColumns } =
    useContext(TableContext);
  const getRowProps = (row) => {
    if (row.original.status === "red") {
      return { style: { background: "#CCCCCC", color: "#000000" } };
    } else if (row.original.status === "green") {
      return { style: { background: "#98fbcb", color: "#000000" } };
    } else if (row.original.status === "purple") {
      return { style: { background: "#c8a2c8", color: "#000000" } };
    } else if (row.original.status === "blue") {
      return { style: { background: "#70d6ff", color: "#000000" } };
    }
  };

  const [navigation, setNavigation] = useState("info");

  // hight attention 0164a7
  // plasmatic concentration 7030a0
  // nezadouci ucinnek f00001

  return (
    <tbody {...getTableBodyProps()}>
      {props.careType === "hospitalization" && (
        <tr role="row">
          <TextFieldFilter
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="external_id"
          />
          <TextFieldFilter
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="name"
          />
          <TextFieldFilter
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="birth_number"
          />
          <NumberFieldFilter
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="age_display"
          />
          <DiagnosisNameFilter
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
          />
          <TextFieldFilter
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="current_care_department_description"
          />
          <TextFieldFilter
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="current_care_last_dekurz_clinic_description"
          />
          <NumberFieldFilter
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="current_care_days"
          />
          <DateFieldFilter
            onChange={props.handleDateChange}
            filter={props.filter}
            field="current_care_last_dekurz_date"
          />
          <TextFieldFilter
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="current_care_doctor_name"
          />
          <td>
            <button className="button" onClick={props.handleResetFilter}>
              Resetovat filtr
            </button>
          </td>
        </tr>
      )}
      {props.careType === "ambulation" && (
        <tr role="row">
          <TextFieldFilter
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="external_id"
          />
          <TextFieldFilter
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="name"
          />
          <TextFieldFilter
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="birth_number"
          />
          <NumberFieldFilter
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="age_display"
          />
          <DiagnosisNameFilter
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
          />
          <TextFieldFilter
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="current_care_department_description"
          />
          <DateFieldFilter
            onChange={props.handleDateChange}
            filter={props.filter}
            field="current_care_started_at"
          />
          <TextFieldFilter
            onChange={props.handleFilterChange}
            onSubmit={props.onSubmit}
            filter={props.filter}
            field="current_care_doctor_name"
          />
          <SelectFieldFilter
            onChange={props.handleFilterChange}
            filter={props.filter}
            options={props.options.category}
            field="current_care_category"
          />
          <td>
            <button className="button" onClick={props.handleResetFilter}>
              Resetovat filtr
            </button>
          </td>
        </tr>
      )}
      {rows.map((row) => {
        prepareRow(row);
        return (
          <Fragment key={row.index}>
            <tr {...row.getRowProps(getRowProps(row))}>
              {row.cells.map((cell) => {
                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
              })}
            </tr>
            {row.isExpanded ? (
              <tr role="row">
                <td
                  colSpan={visibleColumns.length}
                  style={{ flexDirection: "column" }}
                >
                  <div style={{ width: "80%" }}>
                    <PageNavigation className="sub-page-navigation present">
                      <div>
                        <a
                          className={navigation === "info" && "active"}
                          onClick={() => setNavigation("info")}
                        >
                          Informace o pacientovi
                        </a>
                      </div>

                      <div>
                        <a
                          className={navigation === "requests" && "active"}
                          onClick={() => setNavigation("requests")}
                        >
                          Žádanky pacienta ({row.original.requisitions?.length}){" "}
                          {row.original.requisitions?.some(
                            (item) => item.state === "pending"
                          ) && (
                            <IoMdAlert
                              style={{ color: "#A63A49", fontSize: 20 }}
                            />
                          )}
                        </a>
                      </div>
                    </PageNavigation>
                    {navigation === "info" && (
                      <PatientInfoTable
                        id={row.original.id}
                        row={row}
                        careType={row.original.current_care.care_type}
                      />
                    )}
                    {navigation === "requests" && (
                      <PatientRequestsList
                        requisitions={row.original.requisitions}
                        disableCommentSection={true}
                        careId={row.original.current_care.id}
                        careType={props.careType}
                        category={row.original.current_care.category}
                      />
                    )}
                  </div>
                </td>
              </tr>
            ) : null}
          </Fragment>
        );
      })}
    </tbody>
  );
};
